import { toUint16 } from "utils/math/toUint16";
import { hilbertCode } from "utils/math/hilbertCode";
import type { OrderByHilbertCurve, PositionItem } from "./types";

const HILBERT_ORDER = 16;

const compareByPosition = (a: PositionItem, b: PositionItem) =>
  a.position.y - b.position.y || a.position.x - b.position.x;

export const orderByHilbertCurve: OrderByHilbertCurve = ({ elements }) => {
  if (elements.length <= 1) return elements.slice();

  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;

  for (const element of elements) {
    minX = Math.min(minX, element.position.x);
    maxX = Math.max(maxX, element.position.x);
    minY = Math.min(minY, element.position.y);
    maxY = Math.max(maxY, element.position.y);
  }

  return elements.slice().sort((a, b) => {
    const codeA = hilbertCode({
      x: toUint16({ value: a.position.x, min: minX, max: maxX }),
      y: toUint16({ value: a.position.y, min: minY, max: maxY }),
      order: HILBERT_ORDER,
    });
    const codeB = hilbertCode({
      x: toUint16({ value: b.position.x, min: minX, max: maxX }),
      y: toUint16({ value: b.position.y, min: minY, max: maxY }),
      order: HILBERT_ORDER,
    });
    return codeA - codeB || compareByPosition(a, b);
  });
};
